import { Result, Button } from 'antd'
import { useNavigate } from 'react-router-dom'

export default function SessionExpiredPage() {
  const navigate = useNavigate()
  return (
    <Result
      status="warning"
      title="Session Expired"
      subTitle="Your session has expired. Please sign in again to continue."
      extra={
        <Button type="primary" onClick={() => navigate('/login?reason=session_expired')}>
          Sign In
        </Button>
      }
    />
  )
}
